import { nameGenerator } from './helpers/unique-name';

export const mountRootId = `confirm-box-root${nameGenerator()}`;
